import Plan from "./Plan";
import "../css/PlansSection.css";
import colors from '../colors';

function PlansSection()
{
    return(
        <div id="plan-section">

        <h2>پلن های اشتراکی</h2>

        <span  className="plan-container" >

          <Plan type="free"></Plan>
          <Plan type="rocket"></Plan>
          <Plan type="airplane"></Plan>
        </span>

      </div>
    );
}

export default PlansSection;